import { MapboxStyleLayer } from "fond/types";

export const defaultOverrides: MapboxStyleLayer[] = [
  {
    id: "gl-draw-point-stroke-active",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["!=", "meta", "midpoint"], ["==", "active", "true"]],
    paint: {
      "circle-radius": 8,
      "circle-color": "yellow",
    },
  },
];

/**
 * Validation styles for features that have failed validation.
 *
 * These styles apply to features where the "meta:valid" property is set to "false".
 * Features are automatically validated in simpleSelect mode when using layer-specific
 * validation functions.
 *
 * Invalid features are rendered in red with dashed lines/strokes to make them
 * visually distinct from valid features.
 */
export const validationStyles: MapboxStyleLayer[] = [
  // ===== INVALID POINT STYLES =====

  /**
   * Invalid Point features - red circle fill
   */
  {
    id: "gl-draw-point-invalid",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["!=", "meta", "midpoint"], ["==", "user_meta:valid", "false"]],
    paint: {
      "circle-radius": 8,
      "circle-color": "#ff4444",
      "circle-opacity": 0.2,
    },
  },

  /**
   * Invalid Point features - red stroke/outline
   */
  {
    id: "gl-draw-point-stroke-invalid",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["!=", "meta", "midpoint"], ["==", "user_meta:valid", "false"]],
    paint: {
      "circle-radius": 8,
      "circle-color": "transparent",
      "circle-stroke-width": 2,
      "circle-stroke-color": "#ff0000",
      "circle-stroke-opacity": 0.9,
    },
  },

  // ===== INVALID LINESTRING STYLES =====

  /**
   * Invalid LineString features - red dashed line
   */
  {
    id: "gl-draw-line-invalid",
    type: "line",
    filter: ["all", ["==", "$type", "LineString"], ["==", "user_meta:valid", "false"]],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": "#ff0000",
      "line-width": 3,
      "line-dasharray": [2, 2],
      "line-opacity": 0.9,
    },
  },

  // ===== INVALID POLYGON STYLES =====

  /**
   * Invalid Polygon features - red semi-transparent fill
   */
  {
    id: "gl-draw-polygon-fill-invalid",
    type: "fill",
    filter: ["all", ["==", "$type", "Polygon"], ["==", "user_meta:valid", "false"]],
    paint: {
      "fill-color": "#ff0000",
      "fill-outline-color": "#ff0000",
      "fill-opacity": 0.15,
    },
  },

  /**
   * Invalid Polygon features - red dashed stroke
   */
  {
    id: "gl-draw-polygon-stroke-invalid",
    type: "line",
    filter: ["all", ["==", "$type", "Polygon"], ["==", "user_meta:valid", "false"]],
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": "#ff0000",
      "line-width": 3,
      "line-dasharray": [2, 2],
      "line-opacity": 0.9,
    },
  },
];

/**
 * Get validation styles to be added to the map.
 *
 * These should be added BEFORE normal feature styles so they take priority
 * when rendering invalid features.
 *
 * @example
 * import { validationStyles } from './styles';
 *
 * const styles = [
 *   ...validationStyles,  // Invalid features rendered first
 *   ...normalStyles       // Then normal features
 * ];
 */
export default validationStyles;
